package waldo.sankan.lineamunicipalkmp.web.screens

import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.selected
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.css.Color.white
import org.jetbrains.compose.web.dom.*

@Composable
fun GestionComunasScreen(viewModel: AdminPanelViewModel, onBack: () -> Unit) {
    val uiState by viewModel.uiState.collectAsState()
    val rol = (uiState.rolAdmin?.rol ?: "").uppercase().trim()

    Div({
        style {
            padding(20.px)
            fontFamily("sans-serif")
            backgroundColor(Color("#1976D2"))
            minHeight(100.vh)
        }
    }) {
        Div({
            style {
                height(95.vh)
                backgroundColor(Color("#1976D2"))
                borderRadius(12.px)
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
                property("overflow-y", "auto")
            }
        }) {
            // --- CABECERA ---
            Div({
                style {
                    display(DisplayStyle.Flex)
                    property("border-bottom", "2px solid #1565C0")
                }
            }) {
                Div({
                    style {
                        width(10.percent); display(DisplayStyle.Flex); justifyContent(JustifyContent.Center)
                        alignItems(AlignItems.Center); padding(24.px); boxSizing("border-box")
                    }
                }) {
                    Div({ style { display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); alignItems(AlignItems.Center); gap(8.px) } }) {
                        Img(src = "logo_icon.svg", attrs = { style { height(120.px) } })
                        H2({ style { fontSize(24.px); color(Color.white); margin(0.px) } }) {
                            Span({ style { fontWeight("normal") } }) { Text("Linea") }
                            Span({ style { fontWeight("bold") } }) { Text("Muni") }
                        }
                        P(attrs = { attr("translate", "no"); style { fontSize(16.px); color(Color("#FB8C00")); fontWeight("bold"); letterSpacing(1.px); margin(0.px) } }) { Text("SMART CITY") }
                    }
                }

                Div({
                    style {
                        width(90.percent); padding(16.px, 24.px); boxSizing("border-box")
                        display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); gap(16.px)
                    }
                }) {
                    H1({
                        style { color(Color.white); fontSize(32.px); fontWeight(700); textAlign("center"); margin(0.px); paddingTop(20.px) }
                    }) { Text("GESTIÓN DE TERRITORIOS (COMUNAS)") }

                    // --- 🌍 BARRA DE FILTROS ESCALABLE ---
                    Div({
                        style {
                            display(DisplayStyle.Flex); alignItems(AlignItems.Center); gap(16.px)
                            backgroundColor(Color.white); padding(16.px); borderRadius(12.px)
                            property("box-shadow", "0 4px 6px rgba(0,0,0,0.05)")
                            marginBottom(24.px); boxSizing("border-box")
                        }
                    }) {
                        B({ style { color(Color("#1565C0")); fontSize(14.px) } }) { Text("FILTRAR POR:") }

                        Div({ style { display(DisplayStyle.Flex); alignItems(AlignItems.Center); gap(8.px) } }) {
                            B { Text("REGIÓN:") }
                            Select({
                                style { padding(8.px); borderRadius(4.px); minWidth(180.px) }
                                onChange { viewModel.onFiltroRegionChanged(it.target.value) }
                            }) {
                                Option("", attrs = { if (uiState.filtroRegion == null) selected() }) { Text("-- Todas --") }
                                uiState.regiones.forEach { region ->
                                    Option(region.nombre, attrs = { if (uiState.filtroRegion == region.nombre) selected() }) { Text(region.nombre) }
                                }
                            }
                        }

                        Div({ style { flex(1) } }) // 🛡️ EMPUJE TÁCTICO A LA DERECHA

                        Button(attrs = {
                            onClick { onBack() }
                            style {
                                padding(10.px, 20.px); backgroundColor(Color("#FB8C00")) // 🟧 NARANJA
                                color(Color.white); borderRadius(8.px); cursor("pointer"); fontWeight("bold"); border(0.px)
                            }
                        }) { Text("Volver al Panel") }
                    }
                }
            }

            // --- CUERPO PRINCIPAL ---
            Div({
                style { padding(24.px); boxSizing("border-box") }
            }) {
                Div({
                    style {
                        backgroundColor(Color("#1976D2")); padding(24.px); borderRadius(12.px)
                        property("box-shadow", "0 4px 6px rgba(0,0,0,0.1)")
                    }
                }) {
                    H3({
                        style { marginTop(0.px); marginBottom(24.px); property("border-bottom", "1px solid #EEE"); paddingBottom(12.px); color(Color.white) }
                    }) { Text("Estado de Activación por Comuna") }

                    if (uiState.isLoading) {
                        Div({ style { textAlign("center"); padding(40.px); color(Color.white) } }) { Text("Cargando territorios...") }
                    } else {
                        val comunasFiltradas = uiState.comunas.filter {
                            uiState.filtroRegion == null || it.regionDisplayName == uiState.filtroRegion
                        }.sortedBy { it.comunaDisplayName }

                        Div({
                            style { display(DisplayStyle.Grid); gridTemplateColumns("repeat(4, 1fr)"); gap(24.px) }
                        }) {
                            comunasFiltradas.forEach { comuna ->
                                Div({
                                    style {
                                        backgroundColor(Color.white); borderRadius(16.px); padding(24.px)
                                        display(DisplayStyle.Flex); flexDirection(FlexDirection.Column)
                                        property("box-shadow", "0 10px 15px rgba(0,0,0,0.1)"); border(1.px, LineStyle.Solid, Color("#E2E8F0"))
                                    }
                                }) {
                                    Div({ style { marginBottom(16.px) } }) {
                                        H3({ style { margin(0.px); fontSize(18.px); color(Color("#1A202C")); fontWeight("700") } }) { Text(comuna.comunaDisplayName) }
                                        Span({ style { fontSize(12.px); color(Color("#718096")); fontWeight("500") } }) { Text(comuna.regionDisplayName ?: "N/A") }
                                    }

                                    // Activación
                                    Div({
                                        style {
                                            display(DisplayStyle.Flex); alignItems(AlignItems.Center); justifyContent(JustifyContent.SpaceBetween)
                                            property("margin-top", "auto"); paddingTop(16.px); property("border-top", "1px solid #EDF2F7")
                                        }
                                    }) {
                                        Div({ style { display(DisplayStyle.Flex); alignItems(AlignItems.Center); gap(8.px) } }) {
                                            Div({ style { width(8.px); height(8.px); borderRadius(50.percent); backgroundColor(if (comuna.estaActiva) Color("#48BB78") else Color("#F56565")) } })
                                            Span({ style { fontSize(14.px); fontWeight("600"); color(if (comuna.estaActiva) Color("#48BB78") else Color("#F56565")) } }) { Text(if (comuna.estaActiva) "ACTIVA" else "DESACTIVADA") }
                                        }
                                        Button(attrs = {
                                            onClick { viewModel.onCambiarEstadoComuna(comuna, comuna.estaActiva) }
                                            style { padding(8.px, 16.px); borderRadius(10.px); cursor("pointer"); border(0.px); color(Color.white); fontWeight("bold"); backgroundColor(if (comuna.estaActiva) Color("#ED8936") else Color("#4299E1")) }
                                        }) { Text(if (comuna.estaActiva) "OFF" else "ON") }
                                    }

                                    // Noticias
                                    Div({
                                        style { display(DisplayStyle.Flex); alignItems(AlignItems.Center); justifyContent(JustifyContent.SpaceBetween); marginTop(12.px); paddingTop(12.px); property("border-top", "1px dashed #EDF2F7") }
                                    }) {
                                        Span({ style { fontSize(13.px); fontWeight("bold"); color(if (comuna.noticiasHabilitadas) Color("#1976D2") else Color("#718096")) } }) { Text("Módulo Noticias") }
                                        Button(attrs = {
                                            onClick { viewModel.onCambiarAccesoNoticias(comuna, comuna.noticiasHabilitadas) }
                                            style { padding(6.px, 12.px); borderRadius(8.px); cursor("pointer"); color(if (comuna.noticiasHabilitadas) white else Color("#1976D2")); backgroundColor(if (comuna.noticiasHabilitadas) Color("#1976D2") else white); border(1.px, LineStyle.Solid, Color("#1976D2")) }
                                        }) { Text(if (comuna.noticiasHabilitadas) "ACTIVO" else "HABILITAR") }
                                    }

                                    if (comuna.noticiasHabilitadas) {
                                        Div({
                                            style { display(DisplayStyle.Flex); alignItems(AlignItems.Center); justifyContent(JustifyContent.SpaceBetween); marginTop(8.px); padding(8.px); backgroundColor(Color("#F8F9FA")); borderRadius(8.px) }
                                        }) {
                                            Span({ style { fontSize(11.px); color(Color("#555")) } }) { Text("Límite:") }
                                            Input(type = InputType.Number) {
                                                value(comuna.noticiasMensualesLimite); onInput { event -> viewModel.onActualizarLimiteNoticias(comuna, event.value?.toInt() ?: 0) }
                                                style { width(50.px); padding(4.px); borderRadius(4.px); border(1.px, LineStyle.Solid, Color("#CCC")); textAlign("center") }
                                            }
                                        }
                                    }

                                    // 🛡️ BOTÓN DE SIEMBRA (Solo para el General)
                                    if (rol == "GENERAL") {
                                        Div({
                                            style {
                                                display(DisplayStyle.Flex); gap(8.px); marginTop(16.px)
                                            }
                                        }) {
                                            Button(attrs = {
                                                onClick { viewModel.inyectarGabineteComunaActual(comuna) }
                                                style {
                                                    flex(2); padding(10.px); borderRadius(8.px); cursor("pointer")
                                                    backgroundColor(Color("#6A1B9A")); color(Color.white); fontWeight("bold"); border(0.px)
                                                }
                                            }) { Text("📢 SEMBRAR") }

                                            Button(attrs = {
                                                onClick { viewModel.onShowGestionGabineteClicked("comunas/${comuna.id}", comuna.comunaDisplayName) }
                                                style {
                                                    flex(1); padding(10.px); borderRadius(8.px); cursor("pointer")
                                                    backgroundColor(Color("#1976D2")); color(Color.white); fontWeight("bold"); border(0.px)
                                                }
                                            }) { Text("👁️ GABINETE") }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                P({
                    style { marginTop(24.px); color(Color("#666")); fontSize(14.px); fontStyle("italic"); backgroundColor(Color("#E3F2FD")); padding(16.px); borderRadius(8.px); property("border-left", "4px solid #2196F3") }
                }) {
                    Text("Nota: El Administrador General puede sembrar las credenciales base (Alcalde, DAO, Seguridad) para cada territorio.")
                }
            }
        }
    }
}
